import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/bg.ts
var add = "Добави";
var remove = "Премахни";
var removeAll = "Премахни всички";
var incomplete = "Извинете, не всички полета са попълнени правилно.";
var submit = "Изпрати";
var noFiles = "Няма избран файл";
var moveUp = "Преместване нагоре";
var moveDown = "Преместете се надолу";
var isLoading = "Зареждане...";
var loadMore = "Заредете повече";
var next = "Следващ";
var prev = "Предишен";
var addAllValues = "Добавете всички стойности";
var addSelectedValues = "Добавяне на избрани стойности";
var removeAllValues = "Премахнете всички стойности";
var removeSelectedValues = "Премахване на избраните стойности";
var chooseDate = "Избери дата";
var changeDate = "Промяна на датата";
var close = "Затвори";
var open = "Отворете";
var accepted = function({
  name
}) {
  return `Моля приемете ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} трябва да е след ${date(args[0])}.`;
  }
  return `${sentence(name)} трябва да бъде в бъдещето.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} може да съдържа само букви.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} може да съдържа само букви и цифри.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} може да съдържа само букви и интервали.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа азбучни знаци.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа букви или цифри.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа букви или интервали.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа символ.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа главни букви.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа малки букви.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} трябва да съдържа числа.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} трябва да бъде символ.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} може да съдържа само главни букви.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} може да съдържа само малки букви.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} трябва да е преди ${date(args[0])}.`;
  }
  return `${sentence(name)} трябва да бъде в миналото.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Това поле е конфигурирано неправилно и не може да бъде изпратено`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} трябва да бъде между ${a} и ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} не съвпада.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} е невалидна дата. Моля, използвайте формата ${args[0]}`;
  }
  return "Това поле е конфигурирано неправилно и не може да бъде изпратено";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} трябва да бъде между ${date(args[0])} и ${date(args[1])}.`;
};
var email = "Моля, въведете валиден имейл адрес.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} не завършва на ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} е неразрешена стойност.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} трябва да има поне един символ.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} трябва да бъде по-малко или равно на ${max2} символа.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} трябва да бъде ${max2} символи дълго.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} трябва да бъде по-голямо или равно на ${min2} символа.`;
  }
  return `${sentence(name)} трябва да бъде между ${min2} и ${max2} символа.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} е неразрешена стойност.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не може да има повече от ${args[0]} ${name}.`;
  }
  return `${sentence(name)} трябва да бъде по-малко или равно на ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Не са разрешени никакви файлови формати.";
  }
  return `${sentence(name)} трябва да бъде от тип: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не може да има по-малко от ${args[0]} ${name}.`;
  }
  return `${sentence(name)} трябва да бъде поне ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” е неразрешен ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} трябва да бъде число.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" или ")} изисква се.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} е задължително.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} не започва с ${list(args)}.`;
};
var url = function() {
  return `Моля, въведете валиден URL адрес.`;
};
var invalidDate = "Избраната дата е невалидна.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var bg_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, bg_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=bg.mjs.map